
import { InputLabel, MenuItem, Select } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import styled from "styled-components";
import * as yup from "yup";
import { StyledButton } from "../../../../../../components/Button/button";
import { Input } from "../../../../../../components/Input/input";
import { theme } from "../../../../../../helpers/theme";
import { putAddressUpdate } from "../../../../../../services/address/update";
import { PutAddressUpdateRequestBody } from "../../../../../../services/address/update/types";
import { getAllSubcontractor } from "../../../../../../services/subcontractor/get-all";
import { Contractor, HqAdress } from "../../../../../../services/subcontractor/get-all/types";
import { postalCodeRegExp } from "../../../../../../utils/regex";
import { RequiredInfo } from "../../forms-wraper/helpers/required-info";
import { SuccessMessage } from "../../forms-wraper/helpers/success-message";
import { addressVoivodeshipsList } from "../../../../../../helpers/voievodeshipsList";

interface SubcontractorAdresEditeProps {
    id: string,
    adres_id: string | null,
    adress: HqAdress,
    handleClose: () => void;
    setSubcontractors: (element: Contractor[]) => void;
}
type SubcontractorAdresEditeTestedValue = {
    kod_pocztowy: string,
    miejscowosc: string,
    ulica: string | null,
    numer_budynku: string,
    numer_lokalu: string,
    wojewodztwo: string,
};

export const SubcontractorAdresEdite = ({ id, adres_id, adress, handleClose, setSubcontractors }: SubcontractorAdresEditeProps) => {

    const [openSuccessInfo, setOpenSuccessInfo] = useState(false);
    const [changesInData, setChangesInData] = useState(false)
    const handleClick = () => {
        setOpenSuccessInfo(true);
    };

    const startedFormValues: SubcontractorAdresEditeTestedValue = {
        kod_pocztowy: adres_id ? adress.kod_pocztowy : "",
        miejscowosc: adres_id ? adress.miejscowosc : "",
        ulica: adres_id ? adress.ulica : "",
        numer_budynku: adres_id ? adress.numer_budynku : "",
        numer_lokalu: adres_id ? adress.numer_lokalu : "",
        wojewodztwo: adres_id ? adress.wojewodztwo : "",
    }
    const [startedValues, setStartedValues] = useState(startedFormValues);
    const [isDataChange, setIsDataChange] = useState(false);

    const compareValuesInFormWithStartedValues = (
        values: SubcontractorAdresEditeTestedValue,
        newValues: SubcontractorAdresEditeTestedValue) => {
        return !shallowEqual(values, newValues);
    }

    const reGetAllSubcontractor = useMutation(getAllSubcontractor, {
        onSuccess: (data) => {
            setSubcontractors(data.data.payload.wykonawcy);
        },
    });

    const editSubcontractorAdressMutation = useMutation(putAddressUpdate, {
        onSuccess: (res) => {
            reGetAllSubcontractor.mutate({
                paginacja: null,
            });

            setStartedValues({
                kod_pocztowy: formik.values.kod_pocztowy,
                miejscowosc: formik.values.miejscowosc,
                ulica: formik.values.ulica,
                numer_budynku: formik.values.numer_budynku,
                numer_lokalu: formik.values?.numer_lokalu ? formik.values?.numer_lokalu : "",
                wojewodztwo: formik.values.wojewodztwo ? formik.values.wojewodztwo : "",//??
            })


            setIsDataChange(false);
            handleClick();//InfoSuccess
        },
    });

    const validationSchema = yup.object({
        miejscowosc: yup
            .string()
            .required("Miejscowość jest wymagana")
            .max(100, "Maksymalnie 100 znaków"),
        kod_pocztowy: yup
            .string()
            .required("Kod pocztowy jest wymagany")
            .matches(postalCodeRegExp, "Błędny format!")
            .min(6, "Błędny format!")
            .max(6, "Błędny format!"),
        ulica: yup
            .string()
            .nullable()
            .max(100, "Maksymalnie 100 znaków"),
        numer_budynku: yup
            .string()
            .required("Numer budynku jest wymagany")
            .max(5, "Maksymalnie 5 znaków"),
        numer_lokalu: yup
            .number()
            .nullable()
            .min(1, "Minimalna wartość to 1")
            .max(99999, "Maksymalna wartość to 99999")
            .typeError("Numer lokalu od 1 do 99999"),
        wojewodztwo: yup
            .string() //zrobić selecta
            .required("Województwo jest wymagane")
            .max(50, "Maksymalnie 50 znaków"),
        kraj: yup
            .string()
            .max(70, "Maksymalnie 70 znaków"),


    });



    const formik = useFormik({
        initialValues: {
            kod_pocztowy: adres_id ? adress.kod_pocztowy : "",
            miejscowosc_poczty: adres_id ? adress.miejscowosc_poczty : "",
            miejscowosc: adres_id ? adress.miejscowosc : "",
            ulica: adres_id ? adress.ulica : "",
            numer_budynku: adres_id ? adress.numer_budynku : "",
            numer_lokalu: adres_id ? adress.numer_lokalu : "",
            wojewodztwo: adres_id ? adress.wojewodztwo : "",
            kraj: adres_id ? adress.kraj : "Polska",
        },
        validationSchema: validationSchema,
        onSubmit: (values: PutAddressUpdateRequestBody) => {

            setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
                kod_pocztowy: formik.values.kod_pocztowy,
                miejscowosc: formik.values.miejscowosc,
                ulica: formik.values.ulica,
                numer_budynku: formik.values.numer_budynku,
                numer_lokalu: formik.values?.numer_lokalu ? formik.values?.numer_lokalu : "",
                wojewodztwo: formik.values.wojewodztwo ? formik.values.wojewodztwo : "", //?
            }));


            const body = {
                id_wykonawca: id,
                kod_pocztowy: formik.values.kod_pocztowy,
                miejscowosc_poczty: formik.values.kod_pocztowy,
                miejscowosc: formik.values.miejscowosc,
                ulica: formik.values.ulica,
                numer_budynku: formik.values.numer_budynku,
                numer_lokalu: formik.values?.numer_lokalu ? formik.values?.numer_lokalu : null,
                wojewodztwo: formik.values.wojewodztwo,
                kraj: formik.values.kraj,
            }

            if (isDataChange) {
                editSubcontractorAdressMutation.mutate(body);
            }

        },
    });

    useEffect(() => {

        setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
            kod_pocztowy: formik.values.kod_pocztowy,
            miejscowosc: formik.values.miejscowosc,
            ulica: formik.values.ulica,
            numer_budynku: formik.values.numer_budynku,
            numer_lokalu: formik.values?.numer_lokalu ? formik.values?.numer_lokalu : "",
            wojewodztwo: formik.values.wojewodztwo ? formik.values.wojewodztwo : "", //?
        }));

    }, [formik.values]);



    return (
        <Container>
            <form
                onSubmit={formik.handleSubmit}
                onChange={() => setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
                    kod_pocztowy: formik.values.kod_pocztowy,
                    miejscowosc: formik.values.miejscowosc,
                    ulica: formik.values.ulica,
                    numer_budynku: formik.values.numer_budynku,
                    numer_lokalu: formik.values?.numer_lokalu ? formik.values?.numer_lokalu : "",
                    wojewodztwo: formik.values.wojewodztwo ? formik.values.wojewodztwo : "",//??
                }))}>

                <SumamryWraper key="Kod pocztowy">
                    <SummaryItemValue>
                        <Input
                            label="Kod pocztowy*"
                            id="kod_pocztowy"
                            name="kod_pocztowy"
                            value={formik.values.kod_pocztowy}
                            onChange={formik.handleChange}
                            error={formik.touched.kod_pocztowy && Boolean(formik.errors.kod_pocztowy)}
                            helperText={formik.touched.kod_pocztowy && formik.errors.kod_pocztowy}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                fontFamily: `${theme.fonts.interRegular}`,
                                fontSize: "14px",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Miejscowość">
                    <SummaryItemValue>
                        <Input
                            label="Miejscowość*"
                            id="miejscowosc"
                            name="miejscowosc"
                            value={formik.values.miejscowosc}
                            onChange={formik.handleChange}
                            error={formik.touched.miejscowosc && Boolean(formik.errors.miejscowosc)}
                            helperText={formik.touched.miejscowosc && formik.errors.miejscowosc}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Ulica">
                    <SummaryItemValue>
                        <Input
                            label="Ulica"
                            id="ulica"
                            name="ulica"
                            value={formik.values.ulica}
                            onChange={formik.handleChange}
                            error={formik.touched.ulica && Boolean(formik.errors.ulica)}
                            helperText={formik.touched.ulica && formik.errors.ulica}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Numer budynku">
                    <SummaryItemValue>
                        <Input
                            label="Numer budynku*"
                            id="numer_budynku"
                            name="numer_budynku"
                            value={formik.values.numer_budynku}
                            onChange={formik.handleChange}
                            error={formik.touched.numer_budynku && Boolean(formik.errors.numer_budynku)}
                            helperText={formik.touched.numer_budynku && formik.errors.numer_budynku}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Numer lokalu">
                    <SummaryItemValue>
                        <Input
                            label="Numer lokalu"
                            id="numer_lokalu"
                            name="numer_lokalu"
                            value={formik.values.numer_lokalu}
                            onChange={formik.handleChange}
                            error={formik.touched.numer_lokalu && Boolean(formik.errors.numer_lokalu)}
                            helperText={formik.touched.numer_lokalu && formik.errors.numer_lokalu}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper
                    style={{ marginTop: "-18px" }} key="Województwo"
                >
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `#00000099`,
                            fontSize: "11px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "1000",

                        }}
                        >Województwo</InputLabel>
                        <Select
                            id="wojewodztwo"
                            name="wojewodztwo"
                            value={formik.values.wojewodztwo}
                            label="Województwo"
                            onChange={formik.handleChange}
                            variant="filled"
                            disableUnderline //usuwa podkreslenie
                            sx={{
                                width: "100%",
                                backgroundColor: `white`,
                                borderRadius: "8px",
                                "& .Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                    borderRadius: "8px",
                                },
                                "&.active, &:hover, &.active:hover": {
                                    backgroundColor: `white`,
                                    borderRadius: `8px`,

                                },
                            }}
                        >
                            {addressVoivodeshipsList.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                    </SummaryItemValue>
                </SumamryWraper>

                <SumamryWraper key="Kraj">
                    <SummaryItemValue>
                        <Input
                            label="Kraj"
                            id="krajl"
                            name="kraj"
                            value={formik.values.kraj}
                            onChange={formik.handleChange}
                            error={formik.touched.kraj && Boolean(formik.errors.kraj)}
                            helperText={formik.touched.kraj && formik.errors.kraj}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled

                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                backgroundColor: `${theme.colors.gray05_input}`,
                                borderRadius: "8px",
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <RequiredInfo text={"Pola obowiązkowe"} />
                < SuccessMessage message={"Adress podwykonawcy został zmieniony"}
                    setOpenSuccessInfo={setOpenSuccessInfo}
                    openSuccessInfo={openSuccessInfo}
                />
                <ButtonWraper>
                    <StyledButton
                        type="submit"
                        variant="contained"
                        sx={{
                            marginTop: "16px",
                            marginBottom: "16px",
                            marginLeft: "auto",
                            width: "150px",
                        }}
                        disabled={
                            !formik.isValid
                            || !isDataChange
                            || editSubcontractorAdressMutation.isLoading}
                    >
                        Zapisz
                    </StyledButton>
                </ButtonWraper>
            </form >
        </Container >
    );
};
const Container = styled.div`
width:100%;
font-family:${theme.fonts.interMedium},

`;
const SumamryWraper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const SummaryItemValue = styled.div`
padding: 5px 0px;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
overflow-wrap: break-word;
align-content: center;
white-space: break-spaces;
`;

const ButtonWraper = styled.div`
width:100%;
text-align:center;`

const HiddenComponent = styled.div`
display:none;`